import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import 'Components/ProductReviews/OrderItemReviews/OrderItemReviewCard.scss';
import ProductCover from 'Components/Utility/ProductCover';
import RateAndRecommend from 'Components/ProductReviews/UserReviews/RateAndRecommend';
import 'Components/ProductReviews/UserReviews/RecommendedButtons.scss';
import ReviewCardTagButton from 'Components/ProductReviews/OrderItemReviews/ReviewCardTagButton';
import useViewport from 'Hooks/useViewport';
import imageSizes from 'Components/Cards/image-sizes';

const OrderItemReviewCard = ({ item, sizesOverride }) => {
  const {
    name,
    cover,
    _id: productId,
    rating,
    recommended,
    slug,
    published,
    removed,
    hasActiveVersion,
    display_type: displayType,
    type,
  } = item;
  const reviewData = { recommended, rating };
  const { isAboveSm } = useViewport();


  const renderButton = () => <Link
    className="btn btn-primary btn-block review-btn"
    to={`/review/${productId}`}
  >
    {hasActiveVersion && <FormattedMessage id="orderitemreviewcard.editreview" defaultMessage="Edit Review" />}
    {!hasActiveVersion && <FormattedMessage id="orderitemreviewcard.addreview" defaultMessage="Add Review" />}
  </Link>;

  return (
    <div className="three-column-row order-item-review-card-container">
      <div className="order-item-review-card faux-block-link">
        {hasActiveVersion && !published &&
          <div className="moderation-label">
            <FormattedMessage id="orderitemreviewcard.reviewbeingprocessed" defaultMessage="Review Being Processed" />
          </div>
        }
        {removed &&
          <div className="moderation-label">
            <FormattedMessage id="orderitemreviewcard.rejected" defaultMessage="Rejected" />
          </div>
        }
        <ProductCover
          cover={cover}
          alt={`Product cover for ${name}`}
          displayType={displayType}
          sizesOverride={sizesOverride}
        />

        <div className="card-content-container">
          <div className="name-review-button-container">
            <div className="name-container">
              <Link className="faux-block-link__overlay-link" to={`/review/${productId}`}>
                {name}
              </Link>
            </div>
            <div className="review-button-container">
              {renderButton()}
            </div>
          </div>
          <div className="rate-recommend-tag-container">
            <RateAndRecommend
              buttonsOnly
              slug={slug}
              reviewData={reviewData}
              productId={productId}
            />

            {['game', 'dlc'].includes(type) &&
              <ReviewCardTagButton productId={productId} />
            }
          </div>
          <div className="mobile-review-button-container">
            {renderButton()}
          </div>
        </div>

        {isAboveSm &&
          <div className="card-overlay">
            <div className="overlay-content">
              <div className="hover-name-container">
                <Link className="faux-block-link__overlay-link" to={`/review/${productId}`}>
                  <div className="hover-name">
                    {name}
                  </div>
                </Link>
              </div>
              <div className="hover-button-container">
                {renderButton()}
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  );
};

OrderItemReviewCard.propTypes = {
  item: PropTypes.shape({}),
  sizesOverride: PropTypes.string,
};

OrderItemReviewCard.defaultProps = {
  item: {},
  sizesOverride: imageSizes(3, 4, 4, 6),
};

export default OrderItemReviewCard;
